<template>
  <div class="limit_left">
    <div class="limite_header">
      <div class="blue_header">
        <span>{{ $t('limite.movename') }}</span>
      </div>
      <div class="search_limit">
        <div class="search_box">
          <span class="input input--kaede">
            <input
              id="input-35"
              v-model="filterText"
              class="input__field input__field--kaede"
              type="text"
            >
            <label class="input__label input__label--kaede" for="input-35">
              <span class="input__label-content input__label-content--kaede"><i class="el-icon-search" /></span>
            </label>
          </span>
        </div>
      </div>
    </div>
    <div class="limit_body radio_limit">
      <vuescroll>
        <div class="limit_tree_cont">
          <div class="ly-tree-container">
            <el-tree
              ref="tree"
              v-loading="isloading"
              :data="treeData"
              :props="defaultProps"
              show-checkbox
              node-key="id"
              default-expand-all
              :filter-node-method="filterNode"
              :expand-on-click-node="false"

              :check-strictly="true"
              :highlight-current="true"
              @check-change="checkChange"
              @node-click="nodeClick"
            />
          </div>
        </div>
      </vuescroll>
    </div>
  </div>
</template>

<script>
import vuescroll from 'vuescroll';
import { FindUserAreaTree } from '@/axios/IArea';
export default {
	components: {
		vuescroll
	},
	props: {
		disableRootArea: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			filterText: '', //关键字搜索
			defaultProps: {
				children: 'children',
				label: 'label'
			}, //赋值树控件关键字
			treeData:[], //数据树
			isloading:true, //是否加载
		};
	},
	/* mounted(){
		this.$refs.tree.setCheckedKeys([1]);//预先选中id为1的节点;
	}, */
	watch: {
		filterText(val) {
			this.$refs.tree.filter(val);
		}
	},
	mounted() {
		this.doFindUserAreaTree();
	},
	methods: {
		/* 递归获得树形数据
		*/
		functionDoFindUserAreaTree(rs) {
			this.treeData = [];
			if (rs.StatusCode == 0) {
				if (rs.Result.length > 0) {
					rs.Result.forEach((item, index) => {
						this.addArry(item, this.treeData);
					});
				}
			}
			this.isloading = false;
		},
		/* 查询区域树
		*/
		doFindUserAreaTree(){
			this.isloading=true;
			FindUserAreaTree({},this.functionDoFindUserAreaTree);
		},
		/* 树形数据塞入容器
		*/
		addArry(model, fmodel) {
			//通过接口获取到的数据放入区域树model 当前对象 fmodel父对象
			// console.log(model);
			var tempmodel = {};
			tempmodel.id = model.Gpno;
			tempmodel.label = model.GpName;
			// tempmodel.disabled=model.Level==4||tempmodel.id==0?false:true;
			tempmodel.disabled=!(model.Level==this.$store.state.projectarealevel||(tempmodel.id==0&&!this.disableRootArea));
			tempmodel.Level=model.Level;
			if (model.Childs) {
				if (model.Childs.length > 0) {
					tempmodel.children = [];
					model.Childs.forEach((item, index) => {
						this.addArry(item, tempmodel.children);
					});
				}
			}
			fmodel.push(tempmodel);
			// if(tempmodel.id!=0){
			// 	fmodel.push(tempmodel);
			// }

		},
		/* 查询树节点
		*/
		filterNode(value, data) {
			if (!value) return true;
			return data.label.indexOf(value) !== -1;
		},
		/* 点击单选按钮 给调用的页面发送选中的数据
		*/
		checkChange(item, node, self){
			//会有冒泡的出现 后续解决
			// console.log(item);
			if(this.disableRootArea && item.id == 0){
				this.$refs.tree.setCheckedKeys([this.editCheckId]);
				return;
			}
			if (node==true) {//点击未选中复选框
				this.editCheckId = item.id;
				this.$refs.tree.setCheckedKeys([item.id]);
				this.$emit("getareaid",this.editCheckId);
			} else if (this.editCheckId == item.id) {//点击已选中复选框，保证至少一个选中
					this.$refs.tree.setCheckedKeys([item.id]);
					//this.$emit("getareaid",this.editCheckId);
				}

				//console.log('11');


		},
		/* 点击单选按钮 给调用的页面发送选中的数据
		*/
		nodeClick(item, node, self){
			if(item.Level==this.$store.state.projectarealevel||(item.id==0&&!this.disableRootArea)){
				this.editCheckId = item.id;
				this.$refs.tree.setCheckedKeys([item.id]);
				this.$emit("getareaid",this.editCheckId);
			}

		}
	}
};
</script>

<style></style>
